<template>
    <MPModal
        v-model="isOpen"
        variant="center"
        size="md"
        title="Delete file"
    >
        <div class="flex w-full flex-col">
            <div class="text-sm">Are you sure you want to delete this file?</div>
            <div class="mt-3 divide-y divide-gray-200 rounded-muval-2 bg-muval-gray-5">
                <div class="grid grid-cols-5 gap-y-2 p-4 text-sm">
                    <span class="font-medium">File</span>
                    <span class="col-span-4">{{ label }}</span>
                    <template v-if="file?.created_at">
                        <span class="font-medium">Uploaded</span>
                        <time class="col-span-4">
                            {{ dayjs(file.created_at).format('dddd DD MMM YYYY') }} at
                            {{ dayjs(file.created_at).format('h:mm A') }}
                        </time>
                    </template>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex flex-col justify-end gap-2 md:flex-row">
                <MuvalButton
                    cancelBtn
                    class="order-2 md:order-1"
                    @click="isOpen = false"
                >
                    No, keep this file
                </MuvalButton>
                <MuvalButton
                    :loading="loading"
                    class="order-1 md:order-2"
                    @click="emit('confirm')"
                >
                    Yes, delete this file
                </MuvalButton>
            </div>
        </template>
    </MPModal>
</template>

<script setup lang="ts">
import MuvalButton from '@buttons/MuvalButton.vue';
import MPModal from '@components/modal/MPModal.vue';
import useDayJs from '@plugins/useDayJs';
import { getFileDisplayName } from '@utilities/fileDisplay';

/** Confirming a file deletion, shared by every file list. */

const props = withDefaults(
    defineProps<{
        file: Record<string, any> | null;
        /** Overrides the label, matching the row it was opened from. */
        fileLabel?: string;
        loading?: boolean;
    }>(),
    { fileLabel: undefined, loading: false },
);

const emit = defineEmits<{ confirm: [] }>();

const isOpen = defineModel<boolean>({ default: false });

const dayjs = useDayJs();

const label = computed(() => (props.file ? props.fileLabel || getFileDisplayName(props.file) : ''));
</script>
